<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">修改密码</h1>
    </nav>
    <div class="content">
      <div class="list-block">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">手机号</div>
                <div class="item-input">
                  <input type="text" v-model.trim="mobile" placeholder="手机号">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">短信验证码</div>
                <div class="item-input" style="display: inline-block">
                  <input style="width:6rem;display: inline;" type="text" pattern="[0-9]*" v-model.trim="veriCode" placeholder="验证码">
                  <div style="display: inline;width: 2.5rem">
                    <a @click="sendVeriCode" id="btn">发送</a>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">旧密码</div>
                <div class="item-input">
                  <input type="password" v-model.trim="oldPassword" placeholder="旧密码">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">新密码</div>
                <div class="item-input">
                  <input type="password" v-model.trim="newPassword" placeholder="新密码">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">确认新密码</div>
                <div class="item-input">
                  <input type="password" v-model.trim="newPasswordRe" placeholder="重复新密码">
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div class="col-50">
            <router-link :to="{ name: 'me' }" class="button button-big button-fill button-danger">取消</router-link>
          </div>
          <div class="col-50"><a @click="submit" class="button button-big button-fill button-success">确认</a></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import $ from 'jquery'
  import md5 from 'js-md5'

  export default {
    mounted () {
    },
    created () {
    },
    data () {
      return {
        mobile: '',
        veriCode: '',
        coolDown: false,
        oldPassword: '',
        newPassword: '',
        newPasswordRe: '',
        error: ''
      }
    },
    methods: {
      sendVeriCode () {
        let _this = this
        if (!_this.coolDown) {
          _this.gcapi('gcwwwifc/requestPasswordChange', {'LoginId': _this.mobile.replace(/\s+/g, '')}).then((response) => {
            _this.coolDown = true
            time(document.getElementById('btn'))
            $.toast(response.body['message'])
          }, (response) => {
            $.toast(response.body['message'])
          })
        }
        let wait = 60
        function time (o) {
          if (wait === 0) {
            _this.coolDown = false
            o.innerHTML = '发送'
            o.style.color = ''
            wait = 60
          } else {
            o.innerHTML = wait + 's'
            o.style.color = '#C8C8C8'
            wait--
            setTimeout(function () {
              time(o)
            }, 1000)
          }
        }
      },
      checkNewPassword () {
        var _this = this
        if (_this.veriCode === '') {
          _this.error = '请输入验证码'
          return false
        }
        if (!_this.newPassword === _this.newPasswordRe) {
          _this.error = '两次输入不相同'
          return false
        }
        return true
      },
      submit () {
        let _this = this
        if (_this.checkNewPassword()) {
          _this.gcapi('gcwwwifc/submitPasswordChange', {
            'LoginId': _this.mobile.replace(/\s+/g, ''),
            'ExPassword': md5(_this.oldPassword).toUpperCase(),
            'NewPassword': md5(_this.newPassword).toUpperCase(),
            'VerifyCode': _this.veriCode
          }).then((response) => {
            if (response.body.code === 1) {
              $.toast(response.body['message'])
            } else {
              $.toast(response.body['message'])
              _this.$store.state.hasLogin = false
              _this.$router.push('/login')
            }
          }, (response) => {
            $.toast(response.body['message'])
          })
        } else {
          $.toast(_this.error)
        }
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// PasswordChange.vue?f917bee8